module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M21 8h6c.552 0 .684-.316.292-.708L20.706.706C20.316.316 20 .448 20 1v6a1 1 0 0 0 1 1zm6 2h-8a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zM6 25V6H1a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-5H7a1 1 0 0 1-1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/multiple-documents-1.js
// module id = 1293
// module chunks = 14